import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import HomeEssentials from './pages/HomeEssentials';
import HoneymoonFund from './pages/HoneymoonFund';
import GiftPayment from './pages/GiftPayment';
import ScrollToTop from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <ScrollToTop data-id="element-12" />
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/gifts/home-essentials" element={<HomeEssentials data-id="element-17" />} data-id="element-16" />
        <Route path="/gifts/honeymoon-fund" element={<HoneymoonFund data-id="element-19" />} data-id="element-18" />
        <Route path="/gifts/payment" element={<GiftPayment data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}